const Tags = {
  main: {
    pageTag: 'manage_people',
    noRxModal: 'user_not_rxtied_modal',
    get: 'get_started',
    no: 'no_go_back',
    review: 'review_request_link',
    sendInv: 'send_an_invitation_link'
  },
  apiErrorPage: {
    pageTag: 'api_error_page',
    clickTag: 'api_error'
  },
  becomeCaregiverPage: {
    pageTag: 'caregiving_relationship_page',
    clickTag: 'start_now'
  },
  confirmationPage: {
    csr: {
      pageTag: 'csr_verify_page',
      clickTag: 'api_error',
      cancel: 'cancel_button'
    },
    checkBox: {
      submit: 'submit',
      checkedSubmit: 'child_legal_guardian:submit',
      error: {
        type: 'link',
        link: 'custom:account:caregiving_access:minor_page:error',
        field: 'minor_page:confirmation is required.'
      }
    },
    submitCancel: {},
    minor: 'minor_page',
    minorAttest: 'minor_attest',
    adult: 'adult_match_found',
    email: 'adult_match_found_add_email',
    send: 'send_approval_request',
    cancelModal: 'cancel_request_modal',
    cancelMinorAttestModal: 'minor_attest:leave_without_saving_modal',
    keep: 'keep_working',
    leave: 'leave',
    cancel: 'cancel',
    errorTags: {}
  },
  customerCare: {
    call: 'call_customer_care'
  },
  consentPage: {
    pageTag: 'consent_page',
    confirm: 'confirm_button',
    decline: 'decline_button',
    navLink: 'add_and_manage_people_link',
    declineTags: {
      pageTag: 'consent_page',
      modalTag: 'decline_modal',
      buttonTag: 'decline_consent_request_button'
    },
    guestDeclineTags: {
      confirm: 'yes_decline',
      goBack: 'no_go_back',
      pageTag: 'consent_page',
      modalTag: 'decline_access_modal',
      buttonTag: 'decline'
    },
    confirmTags: {
      pageTag: 'consent_page',
      buttonTag: 'confirm_consent_request_button'
    },
    guestConfirmTags: {
      confirm: 'yes_confirm',
      goBack: 'no_go_back',
      pageTag: 'consent_page',
      modalTag: 'confirm_access_modal',
      buttonTag: 'confirm'
    },
    errorTags: {
      authorized: 'authorized',
      declined: 'declined',
      dashboardLink: 'add_and_manage_people_link',
      sendInv: 'send_an_invitation_link'
    }
  },
  healthyCaregiverPage: {
    pageTag: 'healthy_caregiver:set_up',
    continue: 'continue',
    exit: 'exit'
  },
  healthyCaregiverQuestionairePage: {
    pageTag: 'asab',
    buttonTag: 'continue',
    cancelTag: 'exit'
  },
  managePage: {
    pageTag: 'details_helping_someone',
    manage: 'manage_their_rx_button',
    navLink: 'add_and_manage_people_link',
    health: 'health_dashboard_button',
    confirmTags: {
      pageTag: 'details_helping_someone',
      modalTag: 'remove_modal',
      buttonTag: 'remove_from_account_button'
    }
  },
  viewContactPage: {
    pageTag: 'details_helping_someone',
    pagePath: 'suggested_cg:details_helping_someone',
    flowName: 'suggested_cg',
    pageFlag: 'cmk connections',
    add: 'become_their_caregiver',
    adult: 'adult',
    minor: 'minor',
    navLink: 'add_and_manage_people_link',
    remove: 'remove_contact_button',
    confirmTags: {
      pageTag: 'view_contact',
      modalTag: 'remove_modal',
      buttonTag: 'remove_from_account_button'
    },
    fieldError: 'please_try_that_again_something_went_wrong_on_our_end'
  },
  successPages: {
    adult: {
      pageTag: 'adult_request_sent_page',
      manage: 'add_and_manage_people_button',
      h4l: 'back_to_health_dashboard_button'
    },
    minor: {
      pageTag: 'minor_success_page',
      manageRx: 'manage_their_rx_button',
      manage: 'add_and_manage_people_link',
      h4l: 'back_to_health_dashboard_button'
    },
    pet: {
      pageTag: 'pet_success_page',
      manageRx: 'manage_their_account_button',
      manage: 'add_and_manage_people_link',
      h4l: 'back_to_health_dashboard_button'
    },
    confirmed: {
      pageTag: 'consent_page:successfully_consented_signed_in',
      guestPageTag: 'consent_page:successfully_consented_not_signed_in',
      manage: 'add_and_manage_people_button',
      signIn: 'sign_in_button',
      createAccount: 'create_an_account_link'
    },
    declined: {
      pageTag: 'consent_page:successfully_declined_signed_in',
      guestPageTag: 'consent_page:successfully_declined_not_signed_in',
      manage: 'add_and_manage_people_button',
      signIn: 'sign_in_button',
      createAccount: 'create_an_account_link'
    },
    generic: {
      pageTag: 'caregiver_success_page',
      manage: 'add_and_manage_people_button'
    },
    inviteCaregiver: {
      pageTag: 'caregiver_invite_confirmation_email_sent',
      inviteAnother: 'invite_someone_else',
      manage: 'add_and_manage_people'
    },
    healthyCaregiver: {
      pageTag: 'healthy_caregiver:success',
      manage: 'add_and_manage_people'
    }
  },
  viewPage: {
    pageTag: 'details_someone_helping_you',
    navLink: 'add_and_manage_people_link',
    confirmTags: {
      pageTag: 'details_someone_helping_you',
      modalTag: 'remove_access_modal',
      buttonTag: 'remove_access_button'
    }
  },
  lookupErrorPage: {
    pageTag: 'lookup_page',
    alreadyCaringPageTag: 'lookup_page:your_already_caring_for_person',
    pendingPageTag: 'lookup_page:your_request_is_already_pending',
    field_error: 'Relationship already exists.',
    click: 'error',
    click_look_them_up: 'something_went_wrong:look_them_up',
    click_add_and_manage_family: 'something_went_wrong:add_and_manage_people',
    cmk_page_load_error: 'sorry_something_went_wrong_youll_have_to_look_them_up_first_to_help_mange_their_care',
    something_went_wrong: 'something_went_wrong'
  },
  csrLink: {
    pageTag: 'csr-link',
    buttonTag: 'bypass automated verification button'
  },
  userCard: {
    manage: 'manage_people',
    resend: 'resend_request_button',
    link: 'manage_link',
    view: 'view_link',
    cancel: 'cancel_request_button',
    manageCancel: 'manage_people:cancel_request_modal',
    cancelModal: 'cancel_request_modal',
    yes: 'yes_cancel_request_button',
    no: 'no_go_back_button',
    connections: 'connection_details'
  },
  hooks: {
    minor: 'minor_caregiving_success',
    adult: 'adult_caregiving_request_success',
    pet: 'pet_caregiving_success',
    cancel: 'cancel_request_success',
    remove: 'removed_caregivee_success',
    resend: 'resend_request_success',
    revoke: 'removed_caregiver_access_success',
    consent: 'consent_success',
    decline: 'consent_declined_success',
    consent_failure: 'consent_failed',
    locked: 'user profile is locked',
    customerCareNumber: 'customer care phone number',
    customerCare711: 'customer care 711',
    minorAdded: 'childCaregiveeAdded',
    adultAdded: 'adultCaregiveeAdded',
    petAdded: 'petCaregiveeAdded',
    minorAttestError: 'minor_attest:error'
  },
  xidPage: {
    pageTag: 'verify_your_identity',
    invalid: 'link_is_invalid',
    expired: 'link_has_expired',
    locked: 'link_is_locked',
    techError: 'tech_error_page',
    submit: 'verify_and_continue',
    goToCVS: 'go_to_cvs.com',
    tryAgain: 'try_again'
  },
  mfaPage: {
    pageTag: 'send_otp',
    navLink: 'another-way:lexis-nexis'
  },
  otpPage: {
    pageTag: 'validate_otp',
    navLink: 'another-way:rx-label',
    cancel: 'cancel',
    validate_start: 'verification_start',
    validate_success: 'verification_success',
    sms: 'sms'
  },
  mnoPage: {
    pageTag: 'mno_page'
  },
  mfaErrorPage: {
    pageTag: 'xid_mfa_error_page',
    clickTag: 'xid_mfa_api_error'
  },
  xidTechErrorPage: {
    pageTag: 'xid_tech_error_page',
    clickTag: 'xid_api_error'
  },
  inviteCaregiverPage: {
    pageTag: 'caregiver_invite_form',
    submit: 'send_email'
  },
  formErrors: {
    blankFields: 'blank_field_error',
    invalidEmail: 'invalid_email_error'
  },
  minorVerificationOptions: {
    pageTag: 'additional_minor_data',
    textCodeOption: 'text_a_code',
    rxLabelOption: 'use_their_prescription_label',
    cancel: 'cancel',
    confirmTags: {
      confirm: 'leave',
      goBack: 'keep_working',
      pageTag: 'additional_minor_data',
      modalTag: 'leave_request_modal',
      buttonTag: 'cancel'
    }
  },
  flowErrorPage: {
    personInsteadOfPet: {
      pageTag: 'we_found_a_person_instead_of_pet',
      continue: 'continue_adding_person'
    },
    petInsteadOfPerson: {
      pageTag: 'we_found_a_pet_instead_of_a_person',
      continue: 'continue_adding_pet'
    },
    cancel: 'add_and_manage_people',
    rx_label: 'use_a_prescription_label',
    call_us: 'call_us'
  },
  addAPerson: {
    minor: 'add_a_child_link',
    adult: 'add_an_adult_link',
    pet: 'add_a_pet_link',
    infoModal: {
      modal: 'manage_people:adult_info_modal',
      cont: 'continue_link',
      cancel: 'cancel_link'
    }
  },
  peopleFound: {
    pagePath: 'suggested_cg:manage_people',
    flowName: 'suggested_cg',
    maybeLater: 'maybe_later',
    select: 'sugg_caregivee',
    viewAll: 'view_all_people_and_pet',
    addSomeoneElse: 'add_someone_else',
    error: 'error'
  },
  peopleConnectSuccess: {
    pagePath: 'suggested_cg:manage_people_success',
    flowName: 'suggested_cg',
    maybeLater: 'maybe_later',
    viewAll: 'view_all_people_and_pet',
    addSomeoneElse: 'add_someone_else'
  },
  verifyDob: {
    pagePath: 'suggested_cg:dob_verify',
    flowName: 'suggested_cg',
    submit: 'verify_dob',
    cancel: 'cancel',
    tryAgain: 'try_again',
    dismiss: 'dismiss',
    error: 'error',
    dobMismatchPath: 'suggested_cg:dob_verify:error:dob_does_not_match',
    accountLockedPath: 'suggested_cg:dob_verify:error:account_locked',
    manyTimesNoMatchPath: 'suggested_cg:dob_verify:error:many_times_no_match'
  },
  peopleConnectConfirmation: {
    flowName: 'suggested_cg',
    minorPath: 'suggested_cg:minor_attest',
    minorCancelModalPath: 'suggested_cg:minor_attest:cancel_are_you_sure_modal_error',
    adultPath: 'suggested_cg:adult_apprv_no_email',
    adultCancelModalPath: 'suggested_cg:adult_apprv_no_email:cancel_are_you_sure_modal_error',
    adultEmailPath: 'suggested_cg:adult_apprv_email',
    adultEmailCancelModalPath: 'suggested_cg:adult_apprv_email:cancel_are_you_sure_modal_error',
    submit: 'verify_dob',
    sendApprovalRequest: 'send_approval_request',
    cancel: 'cancel',
    error: 'error',
    yesLeave: 'yes_leave',
    noGoBack: 'no_go_back'
  }
};

export default Tags;
